export default function ResultPage() {
  return (
    <div className="result-page">
      <div className="result-card">
        <svg className="result-checkmark" width="80" height="80" viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="36" />
          <path d="M25 42l10 10 20-24" />
        </svg>
        <h1 className="result-title">Verification Complete</h1>
        <p className="result-desc">Your liveness check has been submitted successfully.</p>
        <p className="result-dismiss">You may close this window.</p>
      </div>
    </div>
  );
}
